import React, { useState } from 'react';

export const SecondaryLink = ({ children, theme, onClick }) => {
  const c = theme.colors;
  const t = theme.typography || {};
  const [hover, setHover] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        padding: '8px 14px',
        borderRadius: 6,
        background: hover ? c.bgHover : 'transparent',
        border: `1px solid ${hover ? `${c.accent}66` : c.borderLight}`,
        color: c.textSecondary,
        fontFamily: t.fontFamily,
        fontStyle: 'italic',
        fontSize: '0.86rem',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        transition: 'all 150ms ease',
      }}
    >{children}</button>
  );
};

// Filled / outline button used by the demo card on the sign-in view and
// the campaign view's primary actions.

export const DemoButton = ({ children, theme, icon, variant = 'filled', onClick }) => {
  const c = theme.colors;
  const t = theme.typography || {};
  const e = theme.effects || {};
  const [hover, setHover] = useState(false);
  const filled = variant === 'filled';
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        padding: '11px 16px',
        background: filled
          ? (hover
              ? `linear-gradient(180deg, ${c.accentLight} 0%, ${c.accent} 100%)`
              : `linear-gradient(180deg, ${c.accent} 0%, ${c.accentDark} 100%)`)
          : (hover ? c.bgHover : 'rgba(0,0,0,0.25)'),
        border: filled
          ? `1px solid ${c.accentLight}`
          : `1px solid ${hover ? c.accent : c.borderPrimary}`,
        borderRadius: e.borderRadiusSm || '6px',
        color: filled ? c.textOnAccent : c.accentLight,
        fontFamily: t.fontFamily,
        fontSize: '0.92rem',
        fontWeight: 600,
        cursor: 'pointer',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
        boxShadow: filled && hover ? e.glowAccent : 'none',
        transition: e.transition,
      }}
    >
      <span>{icon}</span> {children}
    </button>
  );
};
